import { IEnvironmentContent } from './environment.interface';
import { StrapiGraphQLURL, StrapiAssetsURL } from '@challenger/care/models/strapi-urls';

export const environment: IEnvironmentContent = {
  appHelpHome: 'https://www.virginmedia.com/help/how-to',
  envName: 'prod',
  deployUrl: '/help/how-to',
  production: true,
  plugins: [],
  graphQLURL: StrapiGraphQLURL.PROD,
  strapiURL: StrapiAssetsURL.PROD,
  assetsPath: '/help/how-to/assets/',
  postcodeSearchUrl: 'https://api.postcodes.io/postcodes',
  tealium: {
    account: 'lgi',
    profile: 'vm-uk-challenger',
    environment: 'prod',
  },
  components: ['vm-footer', 'vm-header', 'vm-breadcrumb', 'vm-opt-in-banner'],
  compaxAngularApi: {
    frontendTokenUrl: '/vm-auth-service/pingfed-auth',
    sessionData: 'session-data',
    findCustomer: 'account/find-by-address',
    serviceStatus: 'diagnostics/check-services',
    findByIp: 'account/find-by-ip',
    paymentUrl: 'billings/billing/payment-url',
    compRegApi: 'diagnostics/auto-compensation/registration',
    diagnosticsStatusApi: 'diagnostics/diagnostic-status',
    placeOrder: 'orders/kit/place-order',
    setApp: 'orders/trouble-call/set-timeslot-code',
    cancelAppointment: 'orders/trouble-call/cancel-order',
    placeTroubleOrder: 'orders/trouble-call/place-order',
    placeTroubleRescheduleOrder: 'orders/trouble-call/reschedule-order',
    macId: 'session-data/select-client-device',
    compaxToken: {
      registerTokenURl: 'vm-auth-service/register-token',
    },
    authToken: {
      url: 'vm-auth-service/oauth/token',
      clientId: 'compax',
      clientSecret: 'compax1',
      grantType: 'client_credentials',
      contentType: 'application/x-www-form-urlencoded',
    },
    workflowEndpoints: {
      start: 'workflow/start',
      current: 'workflow/current',
      back: 'workflow/back',
      next: 'workflow/next',
      nextReturnCode: 'workflow/set-next-returncode',
      goToNextReturnCode: 'workflow/go-to-next-returncode',
      check: 'workflow/check',
    },
    otpEndpoints: {
      create: 'account/otp/create',
      verify: 'account/otp/verify',
      otp: 'account/otp/show-otp-notification',
    },
    manageTransactionData: {
      retrieve: 'account/manage-transaction-data/retrieve',
      create: 'account/manage-transaction-data/create',
    },
  },
  apigeeApi: {
    baseUrl: 'https://api.vmo2digital.co.uk/cpx/',
    dapiAppId: 'La5KYUY4rsEhSCRA3c91ql3lqCBE8erCkw1f1UHpj7FArnJT',
    dapiClientSecret: 'VmyL8ycOZN3jekPmralMubWVTJvdwhVpaOxdA00FFA3aDA8sk879rbbX0SATrMAh',
    dapiChannelId: 'WEB',
    clientId: 'Digital-General-Faults',
    clientSecret: 'JxRCZG4JEHFpztmz',
  },
  authConfig: {
    issuer: 'https://oauth.virginmedia.com',
    redirectUri: 'https://www.virginmedia.com/help/how-to/auth-deflection',
    clientId: 'WEB-VM-SPAGEN1',
    dummyClientSecret: 'STIVky6gPeExyvoCSdhhwngrT5CrDpzdcDgUVITesYGVSrelts8eVa2r6fLwoo1z',
    responseType: 'code',
    scope: 'spagen openid',
    grantType: 'client_credentials',
    sessionChecksEnabled: true,
    useSilentRefresh: true,
  },
  featureFlags: {
    enableIPFromURL: false,
    showOtpInViewBillSeoPage: true,
    showMakeAPaymentInSeoPage: true,
    showOtpInMakeAPaymentSeoPage: true,
  },
  gcp: {
    identificationUrl: 'https://api.vmo2digital.co.uk/faults/workflow/v1/identify',
    order360UpgradeUrl: 'https://api.vmo2digital.co.uk/movers-process/request-new-tv-set',
    dapiChannelId: 'Care-SelfCare-WEB',
    dapiClientSecret: 'lnlzYDi9zqxr7NiLS1N7YZPZ1tNN27uK1yY7ktRveZZGAMhaRGmkNd3o3iQRQHI8',
    dapiAppId: 'PR2HJ4yVbIK6vg0uQLXvqR1GjNX40gLOxkFoKMYeGGlGBrZC',
    oauthServer: 'oAuth',
    userInformation: {
      url: 'https://api.vmo2digital.co.uk/capg/userinformation/user',
      dapiChannelId: 'WEB',
      dapiClientSecret: 'kACw0aQJvBeddkBz2BUcXSQsktYl9AHGpzasiAGfXJh271LFuVKMcf0V3HKJAKkT',
      dapiAppId: 'TM1SLyU5x7oQqccEzJ11rbeSryemAn1X7wfQZ318ddMiBHpD',
    },
    customerInfo: {
      url: 'https://api.vmo2digital.co.uk/capg/v1/customer',
      dapiChannelId: 'BILLING',
      dapiClientSecret: 'fdXGPkeMTq4AXFKXL1sz7TD8jjA7Pwn1kPGJWVVDVOxONzwTt7yQHY703jZMqepC',
      dapiAppId: 'jfpGeQDfD0ihIrULJ0oiAeAhtbrK6iQ3MiH0ac6gwAMDU3rG',
    },    
  },
};
